import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import { useSearch } from 'academy-common-lib/features/search/hooks/useSearch';
import getLang from 'academy-common-lib/utils/getLang';
export const useInternalContentItems = ({
  pageLength,
  skip = false
} = {}) => {
  const variables = {
    languages: [getLang().toUpperCase()],
    pageLength,
    shouldFilterDeprecated: true,
    offset: {
      cursor: 0
    },
    visibilityGroup: 'CUSTOM_CONTENT'
  };
  const {
    searchResults,
    searchResultsLoading,
    searchResultsError,
    totalCount
  } = useSearch({
    variables,
    skip
  });
  const {
    cardModels,
    cardModelsLoading,
    cardModelsError
  } = useLearningContentCardModels({
    items: (searchResults === null || searchResults === void 0 ? void 0 : searchResults.map(item => {
      const {
        id,
        contentType
      } = item;
      return {
        id: id,
        type: contentType === 'TEMPLATE' || contentType === 'EBOOK' ? 'LESSON' : contentType,
        language: 'language' in item ? item.language : undefined
      };
    })) || [],
    skip: !searchResults
  });
  return {
    internalContentItems: cardModels,
    internalContentItemsLoading: searchResultsLoading || cardModelsLoading,
    internalContentItemsError: searchResultsError || cardModelsError,
    totalCount: totalCount || 0
  };
};